import { HelpersService } from '../../../../../services/helpers.service';
declare var Stripe: any;

import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from "../../../../../app.config";
import {CollectionsService} from '../../../../../services/collections.service'

@Component({
  selector: 'app-cyclist-payment',
  templateUrl: './cyclist-payment.component.html',
  styleUrls: ['./cyclist-payment.component.scss']
})
export class CyclistPaymentComponent implements OnInit {
  public helpersService = inject(HelpersService);

  serviceID: string;
  stripe: any;
  card: any;

  cardBrands: any;
  cardNumbers: any;
  loading = false;




  merchantName= "hubtiger";
  merchantBank= "Nedbank";
  currencyFormattedAmount= 20.00
  lineItems: any;
  currency: string;
  excluding: any;
  tax: any;
  total: any;
  partner : any;
  jobcard : any;

  constructor(
    private appConfig: AppConfig,
    public route: ActivatedRoute,
    public collectionsService: CollectionsService
  ) { }

  ngOnInit() {
    this.serviceID = this.route.snapshot.paramMap.get('serviceid');
    this.collectionsService.getServiceJobCard(this.serviceID).subscribe(res=>{
      this.lineItems =  res.invoice.lineItems;
      this.currency = res.invoice.currency;
      this.excluding = res.invoice.excluding;
      this.tax = res.invoice.tax;
      this.total = res.invoice.total;
      this.partner = res.partner;
      this.jobcard = res.number;
    })
    this.initCard();
  }

  initCard(){
    this.stripe = Stripe(this.appConfig.getStripKey());

    var elements = this.stripe.elements();

    this.card = elements.create("card", {
      iconStyle: "solid",
      style: {
        base: {
          iconColor: "#fff",
          color: "#fff",
          fontWeight: 500,
          fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
          fontSize: "16px",
          fontSmoothing: "antialiased",

          ":-webkit-autofill": {
            color: "#fff"
          },
          "::placeholder": {
            color: "#fff"
          }
        },
        invalid: {
          iconColor: "#fff",
          color: "#fff"
        }
      }
    });
    this.card.mount("#example1-card");
  }

  submitPayment() {
    // this.loading = true;
    // this.stripe.createToken(this.card).then(result => {
    //   if (result.error) {
    //     // Inform the user if there was an error.
    //     let errorElement = document.getElementById("card-errors");
    //     errorElement.textContent = result.error.message;
    //   } else {
    //     const partner = this.helpersService.getPartnerData();
    //     // Send the token to your server.
    //     this.paymentService
    //       .postPaymentStripe({
    //         PartnerID: partner.ID,
    //         CardToken: result.token.id,
    //         PlanID: this.chosenPackage.pricing[0].id
    //       })
    //       .subscribe(res => {
    //         this.messageService.add({
    //           life: 3000,
    //           detail: this.translate.instant("bikeshop.package_purchase")
    //         });
    //         this.helpersService.savePartnerData({
    //           ...partner,
    //           PaymentMethod: 1
    //         });
    //         this.router.navigateByUrl("/store/account");
    //         this.modal.close();
    //       });
    //   }
    // });
  }

}
